import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { encryptPayload } from "../../src/utils/EncryptionDecryption";
import apiManager from "../api/apiManager";
import NotAuthorized from "../components/NotAuthorized";
import { isExpired } from "react-jwt";
import getUserRoleFromJWT from "../shared/helpers/getUserRoleFromJWT";
const API_BASE = "/api/dealer";

export const Protected = ({ children, allowedRoles }) => {
  const navigate = useNavigate();
  const [authState, setAuthState] = useState("pending"); // "pending" | "authenticated" | "unauthenticated" | "unauthorized"
  const allowedRolesKey = allowedRoles ? allowedRoles.join(",") : "";

  useEffect(() => {
    setAuthState("pending");
    checkAuthentication();
  }, [allowedRolesKey]);

  const checkAuthentication = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    if (accessToken && !isExpired(accessToken)) {
      resolveAuthState();
      return;
    }
    if (accessToken && refreshToken) {
      try {
        const refreshTokenData = {
          refreshToken: refreshToken,
        };
        const encryptedRefreshToken = encryptPayload(refreshTokenData);
        const { data } = await apiManager.post(
          `${API_BASE}/auth/refresh`,
          encryptedRefreshToken,
          {},
        );
        if (!data) {
          throw new Error("Token refresh returned null or invalid response");
        }
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("accessTokenExpiry", data.accessTokenExpiresAt);
        localStorage.setItem("refreshTokenExpiry", data.refreshTokenExpiresAt);
        resolveAuthState();
      } catch (error) {
        localStorage.clear();
        setAuthState("unauthenticated");
      }
    } else {
      localStorage.clear();
      setAuthState("unauthenticated");
    }
  };

  const resolveAuthState = () => {
    if (allowedRoles && allowedRoles.length > 0) {
      const userRole = getUserRoleFromJWT();
      const normalizedRole =
        userRole !== null && userRole !== undefined ? String(userRole) : null;
      const normalizedAllowed = allowedRoles.map(String);
      if (!normalizedRole || !normalizedAllowed.includes(normalizedRole)) {
        setAuthState("unauthorized");
        return;
      }
    }
    setAuthState("authenticated");
  };

  useEffect(() => {
    if (authState === "unauthenticated") {
      navigate("/");
    }
  }, [authState, navigate]);

  if (authState === "pending") return null;
  if (authState === "unauthenticated") return null;
  if (authState === "unauthorized") return <NotAuthorized />;
  return children;
};
